import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'shd-cross-selling-banner',
    templateUrl: './crossSellingBanner.component.html',
    styleUrls: ['./crossSellingBanner.component.scss'],
    standalone: true,
    imports: [TranslatePipe, CommonModule, FontAwesomeModule]
})
export class CrossSellingBannerComponent {
    @Input()
    public title: string;
    @Input()
    public link: string;
    @Input()
    public image: string;
    @Input()
    public inSidebar: boolean = false;
}
